import React, { useState } from "react";
import Select from "react-select";
import { dialog } from "../../../../../../nq-component";

const AdjustmentTypeModal = ({ onContinue, user, store }) => {
  const [selectedType, setSelectedType] = useState(null);

  const handleContinue = () => {
    if (!selectedType) {
      alert("Please select an adjustment type.");
      return;
    }
    dialog.close();
    onContinue(selectedType.value);
  };

  const isStaff = user?.roles?.some((role) => role.id === "Staff");

  // const adjustmentOptions = isStaff
  //   ? [{ value: "Actual Count", label: "Actual Count" }]
  //   : [
  //       { value: "Beginning Inventory", label: "Beginning Inventory" },
  //       { value: "Manual Add", label: "Manual Add" },
  //       { value: "Manual Deduct", label: "Manual Deduct" },
  //       { value: "Actual Count", label: "Actual Count" },
  //     ];
  const isBeginningDone = store?.[0]?.isBeginningDone;

  const adjustmentOptions = isStaff
    ? [
        // staff ONLY sees Actual Count (no Beginning ever)
        ...(isBeginningDone
          ? [{ value: "Actual Count", label: "Actual Count" }]
          : []),
      ]
    : [
        // non-staff logic
        ...(isBeginningDone
          ? [{ value: "Actual Count", label: "Actual Count" }]
          : [{ value: "Beginning Inventory", label: "Beginning Inventory" }]),

        { value: "Manual Add", label: "Manual Add" },
        { value: "Manual Deduct", label: "Manual Deduct" },
      ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      border: state.isFocused ? "2px solid #83c14a" : "2px solid #E5E7EB",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(131, 193, 74, 0.1)" : "none",
      padding: "6px 8px",
      minHeight: "48px",
      transition: "all 0.3s ease",
      "&:hover": {
        borderColor: "#83c14a",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#9CA3AF",
      fontSize: "0.9375rem",
    }),
    input: (provided) => ({
      ...provided,
      fontSize: "0.9375rem",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#83c14a"
        : state.isFocused
          ? "#F0F9FF"
          : "white",
      color: state.isSelected ? "white" : "#374151",
      padding: "12px 16px",
      cursor: "pointer",
      fontSize: "0.9375rem",
      fontWeight: state.isSelected ? "600" : "500",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "10px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
      border: "2px solid #E5E7EB",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "0.9375rem",
      color: "#111827",
      fontWeight: "500",
    }),
  };

  return (
    <div style={{ padding: "24px", minWidth: "500px" }}>
      <div style={{ marginBottom: "20px" }}>
        <div className="d-flex align-items-center gap-3 mb-3">
          <div
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #83c14a 0%, #6fa83e 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i
              className="bi bi-gear-fill"
              style={{ fontSize: "1.5rem", color: "#fff" }}
            ></i>
          </div>
          <div>
            <h5
              className="mb-1 fw-bold"
              style={{
                color: "#111827",
                fontSize: "1.25rem",
                letterSpacing: "-0.3px",
              }}
            >
              Adjustment Type
            </h5>
            <p className="mb-0 text-muted" style={{ fontSize: "0.875rem" }}>
              Select your preferred adjustment type to continue
            </p>
          </div>
        </div>
      </div>

      <div
        style={{
          background: "linear-gradient(135deg, #F9FAFB 0%, #F3F4F6 100%)",
          borderRadius: "12px",
          padding: "20px",
          border: "1px solid #E5E7EB",
          marginBottom: "24px",
        }}
      >
        <label
          className="form-label fw-bold d-flex align-items-center gap-2 mb-3"
          style={{
            color: "#374151",
            fontSize: "0.875rem",
          }}
        >
          <i className="bi bi-list-check" style={{ color: "#83c14a" }}></i>
          Choose Adjustment Type
        </label>
        <Select
          options={adjustmentOptions}
          placeholder="Select Adjustment Type"
          value={selectedType}
          onChange={setSelectedType}
          styles={customStyles}
        />
      </div>

      <div className="d-flex justify-content-end gap-3">
        <button
          className="btn"
          onClick={() => dialog.close()}
          style={{
            background: "#fff",
            border: "2px solid #E5E7EB",
            color: "#374151",
            padding: "10px 24px",
            borderRadius: "10px",
            fontSize: "0.9375rem",
            fontWeight: "600",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#F9FAFB";
            e.currentTarget.style.borderColor = "#D1D5DB";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#fff";
            e.currentTarget.style.borderColor = "#E5E7EB";
          }}
        >
          <i className="bi bi-x-circle me-2"></i>
          Cancel
        </button>
        <button
          className="btn"
          onClick={handleContinue}
          style={{
            background: "linear-gradient(135deg, #83c14a 0%, #6fa83e 100%)",
            border: "none",
            color: "#fff",
            padding: "10px 24px",
            borderRadius: "10px",
            fontSize: "0.9375rem",
            fontWeight: "600",
            boxShadow: "0 4px 12px rgba(131, 193, 74, 0.3)",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow =
              "0 6px 20px rgba(131, 193, 74, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 4px 12px rgba(131, 193, 74, 0.3)";
          }}
        >
          <i className="bi bi-arrow-right-circle me-2"></i>
          Continue
        </button>
      </div>
    </div>
  );
};

export default AdjustmentTypeModal;
